import {AccountTypeEntityModel} from "../../account-type-entity.model";
import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {Component} from "@angular/core";
import {AccountTypeData} from "../../account-type.data";

@Component({
    selector: "wbo-account-type-edit-billing-terms",
    templateUrl: "./account-type-edit-billing-terms.component.html"
})
export class AccountTypeEditBillingTermsComponent {

    AccountTypeData = AccountTypeData;

    constructor(public model: AccountTypeEntityModel, public editService: EditService) {
    }

    changeValidBillingCycles(): void {
        if (this.model.data.validBillingCycles.length === 0) {
            this.model.data.validBillingCycles = [AccountTypeData.BILLING_CYCLE_NONE];
        }

        if (this.model.data.validBillingCycles.find((value) => value === this.model.data.defaultBillingCycleDbValue) === undefined) {
            this.model.data.defaultBillingCycleDbValue = this.model.data.validBillingCycles[0];
        }
    }
}
